module.exports = __webpack_public_path__ + "media/connectivity-slide2.8131d6c8.mp4";